"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackoffWithEffect = exports.Backoff = void 0;
var Backoff = /** @class */ (function () {
    function Backoff(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.min, min = _c === void 0 ? 50 : _c, _d = _b.max, max = _d === void 0 ? 5000 : _d, _e = _b.factor, factor = _e === void 0 ? 2 : _e, _f = _b.random, random = _f === void 0 ? .2 : _f;
        this.level = 0;
        this.reset = function () { _this.level = 0; };
        this.next = function () {
            var ms = _this.min * (Math.pow(_this.factor, _this.level++));
            ms = Math.min(ms, _this.max);
            var rand = (2 * Math.random() - 1) * _this.random;
            var offset = rand * ms;
            return Math.min(Math.floor(ms + offset), _this.max);
        };
        this.min = min;
        this.max = max;
        this.factor = factor;
        this.random = random;
    }
    return Backoff;
}());
exports.Backoff = Backoff;
var BackoffWithEffect = /** @class */ (function () {
    function BackoffWithEffect(opts) {
        var _this = this;
        this.schedule = function (callback) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (_this.handle) {
                return;
            }
            var next = _this.backoff.next();
            _this.callback = callback;
            _this.handle = setTimeout.apply(void 0, __spreadArrays([_this.fire, next], args));
        };
        this.fire = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.handle = undefined;
            var cb = _this.callback;
            _this.callback = undefined;
            var effectResult = _this.effect.apply(_this, args);
            if (cb) {
                cb(effectResult);
            }
        };
        this.reset = function () {
            if (_this.handle) {
                clearTimeout(_this.handle);
                _this.handle = undefined;
                _this.callback = undefined;
            }
            _this.backoff.reset();
        };
        this.backoff = new Backoff(opts);
        this.effect = opts.effect;
    }
    Object.defineProperty(BackoffWithEffect.prototype, "level", {
        get: function () { return this.backoff.level; },
        enumerable: false,
        configurable: true
    });
    return BackoffWithEffect;
}());
exports.BackoffWithEffect = BackoffWithEffect;
//# sourceMappingURL=backoff.js.map